<div class="statuses-container">
	@for (status of statuses$ | async; track status) {
		<mat-checkbox
			color="primary"
			class="au-checkbox"
			[checked]="isChecked(status)"
			(click)="$event.stopPropagation()"
			(change)="toggleSelection($event, status)"
		>
			<au-cmms-status-label [status]="status"> </au-cmms-status-label>
		</mat-checkbox>
	}
</div>
